import { useSyncExternalStore } from 'react';

/**
 * Bearbeitete Bildversionen werden unter gleicher URL ueberschrieben. Damit
 * Galerie und Editor danach nicht das gecachte alte Bild zeigen, wird pro
 * Datei-ID eine Version gefuehrt, die als Query-Parameter nur an die im DOM
 * verwendete URL angehaengt wird (nicht an das gespeicherte HTML).
 */
const versions = new Map<number, number>();
const listeners = new Set<() => void>();

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const bumpImageVersion = (fileId: number): void => {
  versions.set(fileId, Date.now());
  listeners.forEach((l) => l());
};

export const useImageVersion = (fileId: number | null | undefined): number =>
  useSyncExternalStore(subscribe, () => (fileId ? versions.get(fileId) ?? 0 : 0));

export const withImageVersion = (url: string, version: number): string =>
  version ? `${url}${url.includes('?') ? '&' : '?'}v=${version}` : url;

/** Datei-ID aus einer Preview-URL (`/api/files/{id}/preview`, auch restricted). */
export const fileIdFromPreviewUrl = (url: string | null | undefined): number | null => {
  if (!url) return null;
  const m = /\/files\/(\d+)\/preview/.exec(url);
  return m ? Number(m[1]) : null;
};
